<template>
  <div>
    <basic-container>
      <div style="height: 20px"></div>
      <el-form :inline="true" ref="form" :model="form">
        <el-row>
          <el-col span="6">
            <el-form-item
              label="停车场"
              prop="spaceId"
              :rules="[{ required: true, message: '请选择停车场', trigger: 'blur' }]"
            >
              <el-select
                multiple
                v-model="form.spaceId"
                filterable
                collapse-tags
                style="margin-left: 20px"
                placeholder="请选择"
                @change="spaceChange"
              >
                <el-option
                  v-for="item in spaceList"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item
              label="支付时间"
              prop="payTime"
              :rules="[{ required: true, message: '请选择支付时间', trigger: 'blur' }]">
              <el-date-picker
                label="停车场"
                v-model="form.payTime"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">立即查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <WebReport ref="WebReport" :url="url" :params="params" :roomName="roomName" :name="name"/>
    </basic-container>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import WebReport from '@/components/web-report';
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  import done from '../../work/done';
  import urlSettings from '@/config/url-settings.js';
  export default {
    components: {
      WebReport,
    },
    data() {
      //设置默认时间
      const myDate = new Date();
      const year = myDate.getFullYear();
      const month = (myDate.getMonth()+1) < 10 ? "0"+(myDate.getMonth()+1) : (myDate.getMonth()+1);
      const day = myDate.getDate() < 10 ? "0"+myDate.getDate() : myDate.getDate();
      const startDay = year+"-"+month+"-01 00:00:00"
      const endDay = year+"-"+month+"-"+day+" 23:59:59";

      return {
        url: '',
        form: {
          payTime:[startDay,endDay],
          spaceId: [],
          payTimeStrat: '',
          payTimeEnd: '',
        },
        spaceList: [],
        oldOptions: [],
        params: {
          reportlet: urlSettings.VUE_APP_ENVIRONMENT + '/carMonthStatic.cpt',
          // reportlet: 'pmsone/carMonthStatic.cpt',
        },
        dic: [],
      };
    },
    methods: {
      initPropertyList() {

        //设置车场下拉
        getSpaceTree().then((data) => {
          this.spaceList = data.data;
          let obj = {};
          obj.title = '全部';
          obj.id = '0000';
          this.spaceList.unshift(obj);
          this.form.spaceId.push(this.spaceList[1].id);
          this.form.payTimeStrat = this.form.payTime[0];
          this.form.payTimeEnd = this.form.payTime[1];
          this.params.spaceId = `(${this.spaceList[1].id})`;
          this.params.payTimeStrat = this.form.payTime[0];
          this.params.payTimeEnd = this.form.payTime[1];
          console.log("初始化月卡车收费统计请求参数：" + this.params);
          var reportUrl = urlSettings.BASE_REPORT_URL;
          this.url = reportUrl.split('?')[0];
          // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2FcarMonthStatic.cpt';
          setTimeout(() => {
            this.$refs.WebReport.regroupUrl();
          }, 0);
        });
      },
      spaceChange(val) {
        let allValues = []; //保留所有值
        let value = []; //保留所选的值

        for (let item of this.spaceList) {
          allValues.push(item.id);
        }
        // 用来储存上一次的值，可以进行对比
        const oldVal = this.oldOptions;

        // 若是全部选择
        if (val.indexOf('0000') != -1) {
          value = allValues;
        }

        // 取消全部选中  上次有 当前没有 表示取消全选
        if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') == -1) {
          value = [];
        }

        // 点击非全部选中  需要排除全部选中 以及 当前点击的选项
        // 新老数据都有全部选中
        if (oldVal.indexOf('0000') != -1 && val.indexOf('0000') != -1) {
          if (val.length < allValues.length) {
            const index = val.indexOf('0000');
            val.splice(index, 1); // 排除全选选项
            value = val;
          } else {
            value = val;
          }
        }

        //全选未选 但是其他选项全部选上 则全选选上 上次和当前 都没有全选
        if (oldVal.indexOf('0000') == -1 && val.indexOf('0000') == -1) {
          if (val.length === allValues.length - 1) {
            value = ['0000'].concat(val);
          } else {
            value = val;
          }
        }

        //储存当前最后的结果 作为下次的老数据
        this.oldOptions = value;
        this.form.spaceId = value;
      },
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.params.spaceId = `(${this.form.spaceId.join(',')})`;
            this.params.payTimeStrat= this.dayjs(this.form.payTime[0]).format('YYYY-MM-DD HH:mm:ss');
            this.params.payTimeEnd = this.dayjs(this.form.payTime[1]).format('YYYY-MM-DD HH:mm:ss');

            var reportUrl = urlSettings.BASE_REPORT_URL;
            this.url = reportUrl.split('?')[0];
            // this.url = 'http://localhost:8075/WebReport/ReportServer?reportlet=pmsone%2FcarMonthStatic.cpt';
            setTimeout(() => {
              this.$refs.WebReport.regroupUrl();
            }, 0);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    },

    created() {
      this.initPropertyList();
    },
  };
</script>

<style></style>
